import toast from 'react-hot-toast'

import { useMutation } from '@fv/client-core'
import type { ListShipment } from '@fv/client-types'
import type { AccountSettings, DocumentBatchRequest } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

import {
  getEligibleLoadIdsForType,
  toBatchDocumentType,
} from './batchPrintEligibility'
import type { BatchPrintDocumentType } from './types'

type BatchPrintParams = {
  loads: ListShipment[]
  shipping: AccountSettings['shipping']
  type: BatchPrintDocumentType
}

async function requestDocumentBatch({
  loads,
  shipping,
  type,
}: BatchPrintParams) {
  const loadIds = getEligibleLoadIdsForType(loads, shipping, type)
  if (loadIds.length === 0) {
    throw new Error('No eligible shipments for this document type')
  }

  const body: DocumentBatchRequest = {
    loadIds,
    documentType: toBatchDocumentType(type),
  }

  await shipperFetch('/documents/batch', {
    method: 'POST',
    body,
  })
}

export function useBatchPrintDocument() {
  return useMutation({
    mutationFn: requestDocumentBatch,
    onSuccess: () => {
      toast.success(
        'Your documents are being prepared. You will be notified when they are ready.',
        { duration: 6000 },
      )
    },
  })
}
